<script setup lang="ts">
  import { onMounted, onBeforeUnmount } from "vue";
  import { useBarcode, useDeviceInfo } from "@plugins";
  import { authorize, UserRole, useShopLoad } from "@src/api";
  import { useProfileOptions } from "@src/hooks";
  import { StatusBar, PressScan } from "@src/components";
  import { useUserInfoStore } from "@src/store";
  import { default as LoginPageUserInfo } from "./LoginPageUserInfo.vue";
  import { default as LoginPageScan } from "./LoginPageScan.vue";

  const barcode = useBarcode();
  const { getInfo } = useDeviceInfo();
  const { mutateAsync: authorizeMutate } = authorize();
  const { profile, clearProfile, getProfile } = useProfileOptions();
  const { execute: shopLoad } = useShopLoad();
  const userInfoStore = useUserInfoStore();

  onMounted(async () => {
    barcode.subscribe(async (barcode) => {
      const info = await getInfo();
      const { token } = await authorizeMutate({ qrCode: barcode, deviceId: `device-${info.id}` });

      if (token) {
        const profile = await getProfile();

        if (profile.data.value.current_user.shop_id) {
          const { isSuccess, data } = await shopLoad({ shop_id: profile.data.value.current_user.shop_id });

          if (isSuccess) {
            userInfoStore.setShop(data.value.shop);
          }
        }
      }
    });
  });

  onBeforeUnmount(barcode.unsubscribe);
</script>

<template>
  <div class="login-page" data-testid="login-page">
    <StatusBar />
    <PressScan :text="$t('Нажмите кнопку сбоку,<br />чтобы отсканировать код')" />
    <LoginPageUserInfo
      v-if="profile && profile.current_user?.role !== UserRole.guest"
      :first-name="profile?.current_user?.first_name"
      :last-name="profile?.current_user?.last_name"
      :store="userInfoStore.shop?.title"
      @clear-user="clearProfile"
    />
    <LoginPageScan v-else />
  </div>
</template>

<style scoped>
  .login-page {
    display: flex;
    flex-direction: column;
    flex: 1;
    background-color: #000000;
  }

  .login-page :deep(.statusbar) {
    background-color: #000000;
  }

  .login-page :deep(.statusbar__icon) {
    stroke: #ffffff;
  }

  .login-page :deep(.statusbar__battery-icon) {
    fill: #ffffff;
  }

  .login-page :deep(.statusbar__battery-text) {
    color: #000000;
  }

  .login-page .press-scan {
    margin: 175px 4px 0;
  }

  .login-page .footer {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    margin-top: auto;
    background-color: #ffffff;
    border-radius: 16px 16px 0 0;
    padding: 24px 16px;
  }

  .login-page .footer .icon {
    margin-top: 24px;
  }

  @keyframes arrow {
    from {
      gap: 8px;
    }

    50% {
      gap: 4px;
    }

    to {
      gap: 8px;
    }
  }
</style>
